<template>
    <section class="container-fluid">
        <div class="row no-gutters pb-2" data-cs-mask>
            <div class="col-12 px-0">
                <EligibilityInfo :eligibility-info="eligibilityResult.eligibilityInfo" />
            </div>
            <div v-if="showBottomElipiLink" class="col-12 px-1 px-md-0 mt-1">
                <button
                    class="ob1-link-arrow"
                    type="submit"
                    form="tester-eligibilite"
                    name="position"
                    :value="eligibilityResult.position"
                    :data-oevent-category="eligibilityResult.linkTms.category"
                    :data-oevent-label="eligibilityResult.linkTms.label"
                    :data-oevent-action="eligibilityResult.linkTms.action"
                >
                    {{ eligibilityResult.elipiLabel }}
                </button>
            </div>
        </div>
    </section>
</template>

<script>

import EligibilityInfo from "./EligibilityInfo.vue";

export default {
    name: "EligibilityResult",
    components: {
        EligibilityInfo
    },
    props: {
        eligibilityResult: {type: Object, required: true},
    },
    computed: {
        showBottomElipiLink: function() {
            return this.eligibilityResult.showElipiLink && (this.eligibilityResult.eligibilityInfo.testChips == null)
        }
    }
}
</script>

<style scoped>

</style>
